import {
    getDiseaseList,
    getInfo,
    lookup,
    search
} from "./api";
import { DiseaseKnowledgeDialogMode } from "./DiseaseKnowledgeDialogMode";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/DiseaseKnowledge",
    getDiseaseList: "getDiseaseList",
    getInfo: "getInfo",
    lookup: "lookup",
    search: "search",
    openDialog: "openDialog",
    closeDialog: "closeDialog",
    setKeyword: "setKeyword",
    clearKeyword: "clearKeyword",
    initExtractedDiseases: "initExtractedDiseases",
});


export const getListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getDiseaseList}`,
    async (_, { rejectWithValue }) => {
        const response = await getDiseaseList();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return response;
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const getInfoAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getInfo}`,
    async (diseaseId: string, { rejectWithValue }) => {
        const response = await getInfo(diseaseId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return response;
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const lookupAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.lookup}`,
    async (diseaseNames: string[], { rejectWithValue }) => {
        const response = await lookup(diseaseNames);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return response;
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const searchAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.search}`,
    async (keyword: string, { rejectWithValue }) => {
        const response = await search(keyword);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return response;
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const openDialogAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.openDialog}`,
    async (dialogMode: DiseaseKnowledgeDialogMode) => {
        return dialogMode;
    }
);

export const closeDialogAction = createAction(`${ActionType.base}/${ActionType.closeDialog}`);

export const setKeywordAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.setKeyword}`,
    async (keyword: string) => {
        return keyword;
    }
);

export const clearKeywordAction = createAction(`${ActionType.base}/${ActionType.clearKeyword}`);

export const initExtractedDiseasesAction = createAction(`${ActionType.base}/${ActionType.initExtractedDiseases}`);
